import { BoumRight } from '@moia-dev/moia-token-claims'

/**
 * Opening the Stop Network needs the area right, and creating a road blockage
 * once there needs the road blockage CRUD right — the map hides its create
 * control without it, so the entry points would lead to a dead end.
 */
export const ROAD_BLOCKAGE_CREATION_RIGHTS = [
  BoumRight.AREA_STOP_NETWORK,
  BoumRight.CSR_BLOCKED_ROAD_CRUD,
] as const
